import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Input from '../Input';
import UserAddressDisplay from '../user-address/UserAddressDisplay';

const propTypes = {
  onCabinNameSet: PropTypes.func,
  onIdentityNameSet: PropTypes.func.isRequired,
  cabinName: PropTypes.string,
  identityName: PropTypes.string,
  externalAddresses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      address_line_1: PropTypes.string.isRequired,
      address_line_2: PropTypes.string,
      post_code: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      country: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  ),
};

const WaldogramAddressPlaceholder = ({
  cabinName,
  identityName,
  onIdentityNameSet,
  onCabinNameSet,
  externalAddresses = [],
}) => {
  return (
    <div className="waldogram-address-placeholder">
      <span className="waldogram-address-placeholder-title">TO:</span>

      {externalAddresses.length > 1 && (
        <div className="mt-1 text-faded">
          Delivered to multiple addresses ({externalAddresses.length}).
        </div>
      )}

      {externalAddresses.length === 1 && (
        <div className="waldogram-address-placeholder-display">
          <UserAddressDisplay address={externalAddresses[0]} />
        </div>
      )}

      {!externalAddresses.length && (
        <Fragment>
          <Input
            id="waldogram-identity-name"
            className="waldogram-identity-name"
            placeholder="Camper's name..."
            value={identityName}
            onChange={event => {
              const { value } = event.target;
              onIdentityNameSet(value);
            }}
          />

          {onCabinNameSet && (
            <Input
              id="waldogram-cabin-name"
              className="waldogram-cabin-name"
              placeholder="Cabin..."
              value={cabinName}
              onChange={event => {
                const { value } = event.target;
                onCabinNameSet(value);
              }}
            />
          )}
        </Fragment>
      )}
    </div>
  );
};

WaldogramAddressPlaceholder.propTypes = propTypes;

export default WaldogramAddressPlaceholder;
